import { Link } from 'react-router-dom';

export default function CTA() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="relative max-w-7xl mx-auto rounded-2xl overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=Warm%20and%20inviting%20anime%20community%20scene%20with%20characters%20gathering%20under%20cherry%20blossom%20trees%2C%20soft%20golden%20sunlight%2C%20peaceful%20and%20harmonious%20atmosphere%2C%20Japanese%20animation%20aesthetic%2C%20pastel%20colors%2C%20friendship%20theme&width=1400&height=500&seq=cta-bg-01&orientation=landscape')`,
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/80 via-foreground-900/60 to-foreground-900/40"></div>
        </div>

        <div className="relative z-10 px-6 py-14 md:py-20 text-center">
          <h2 className="font-heading text-2xl md:text-4xl text-white">
            加入萝幼社，探索属于你的二次元世界
          </h2>
          <p className="mt-4 text-sm md:text-base text-white/70 max-w-xl mx-auto leading-relaxed">
            无论你是创作者还是爱好者，这里都有属于你的位置。与千万同好一起，分享热爱，创造美好。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
            <Link
              to="/category/illustration"
              className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              立即加入
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 rounded-full border border-white/30 text-white font-medium text-sm hover:bg-white/10 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              了解详情
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}